export const BootstrapInfoLocalKey = 'bootstrap_info';

export function getBootstrapInfoFromLocal() {
  const storage = window.localStorage.getItem(BootstrapInfoLocalKey);
  if (!storage) return null;
  return JSON.parse(storage);
}

export function setBootstrapInfoToLocal(bootstrapInfo) {
  window.localStorage.setItem(
    BootstrapInfoLocalKey,
    JSON.stringify(bootstrapInfo),
  );
}

export function removeBootstrapInfoFromLocal() {
  window.localStorage.removeItem(BootstrapInfoLocalKey);
}
